import cn from 'classnames';
import React, { InputHTMLAttributes } from 'react';
import styles from './styles.module.css';

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  inputClassName?: string;
  label?: string;
  placeholder?: string;
  name: string;
  error?: string;
  type?: string;
  testId?: string;
}

const classes = {
  root: styles.root,
};

export const Input = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      className = 'block',
      label,
      name,
      error,
      placeholder,
      type = 'text',
      inputClassName,
      testId,
      ...rest
    },
    ref
  ) => {
    const baseTestId = testId;
    const inputTestId = baseTestId ? `${baseTestId}-input` : name;
    const labelTestId = baseTestId ? `${baseTestId}-label` : `input-label-${name}`;
    const errorTestId = baseTestId ? `${baseTestId}-error` : `input-error-${name}`;
    const rootClassName = cn(classes.root, inputClassName);

    return (
      <div className={className} data-testid={baseTestId ? `${baseTestId}-root` : `input-root-${name}`}>
        {label && (
          <label
            htmlFor={name}
            className={styles.label}
            data-testid={labelTestId}
          >
            {label}
          </label>
        )}
        <input
          data-testid={inputTestId}
          id={name}
          name={name}
          type={type}
          ref={ref}
          placeholder={placeholder}
          className={rootClassName}
          autoComplete="off"
          spellCheck="false"
          {...rest}
        />
        {error && <p className="my-2 text-xs text-red-500" data-testid={errorTestId}>{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
